export const CATEGORY_V2 = 'categoryV2';
export const PRICING = 'planType';
export const PLAN_COMPATIBLE = 'onlyHubInstallable';
export const TIERS = 'tiers';
export const HUBSPOT_FEATURES = 'hubSpotFeatures';
export const INTEGRATIONS = 'integrations';
export const CREDENTIALS = 'credentials';
export const SYNC = 'sync';
export const APP_LANGUAGES = 'appLanguages';
export const SUPPORT_LANGUAGES = 'supportLanguages';
export const SUPPORT_SOURCE = 'supportSource';
export const SEARCH = 'search';
export const SORTS = 'sorts';
export const SORT_FIELD = 'sortField';
export const SORT_ORDER = 'sortOrder';
export const OPS_HUB = 'opsHub';
export const SHOW_PREFERRED_LANG_FIRST = 'showPreferredLanguageFirst';